export default {
  "custom": {
    linkedReference: 'התייחסות מקושרת',
    boot: 'הפעל',
    shutDown: 'כבה',
    notLinked: 'לא מקושר',
    maxLinkedTip: 'מותר לכל היותר 2 קישורים מסוג {type}, הוחזר אוטומטית למצב לא מקושר',

    bar_Power: 'בקרת חשמל',
    bar_Video: 'החלפת וידאו',
    bar_Vol: 'עוצמת קול',
    bar_Audio: 'החלפת שמע',
    bar_Serial: 'בקרת סריאל',
    bar_Air: 'מזגן',
    bar_Projection: 'מסך הקרנה',
    bar_Remote: 'שלט רחוק',
    bar_Matrix: 'IQShare Matrix',
    "youMustSelectAllThreeImagesAtTheSameTime": "עליך לבחור את כל שלוש התמונות בו זמנית",
    "notSelected": "לא נבחר",
    "choose": "בחר",
    "disable": "השבת",
    "longPressAndDrag": "לחץ והחזק וגרור כדי להתאים את סדר הרשימה",
    "isrestoreDefault": "האם ברצונך לשחזר למצב ברירת מחדל?",
    "saveAndSync": "שמור וסנכרן",
    "restoreDefault": "שחזר לברירת מחדל",
    "limitPNG": "ניתן להעלות רק תמונות PNG!",
    "limit1M": "גודל התמונה אינו יכול לעלות על 1MB!",
    "selectTheImage": "בחר תמונה",
    "textsuggestions": "מומלץ: אייקון PNG לבן בגודל 48*48 px מתחת ל-1MB",
    "iconLibrary": "ספריית אייקונים",
    "panelNavigationBarCustomization": "סרגל ניווט הפאנל",
    "logoCustomization": "לוגו הפאנל"
  },
  "outlook": {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Binding failed: This Microsoft tenant (ID: ',
    AuthVerify4004Two: ") is already occupied by the organization [",
    AuthVerify4004Three: "].To rebind, please first unbind it from the original organization or use a different Microsoft tenant.",
    theMicrosoftTenantIsOccupied: 'The Microsoft tenant is occupied',
    "Viewtutorial": "צפה במדריך הקשירה",
    "checktenantID": "אנא בדוק אם מזהה הדייר, מזהה האפליקציה ומפתח האפליקציה נכונים.",
    "ErrorCode": "קוד שגיאה:",
    "AuthorizationFailed": "הסמכה נכשלה",
    "Accesshasbeengranted": "הגישה ל-Microsoft Graph API אושרה",
    "successfullyauthorizedDescribe": "הרשאות נדרשות אושרו בהצלחה. נתוני חדרי הישיבות יסונכרנו אוטומטית. אנא סגור דף זה.",
    "Close": "סגור",
    "resourceID": "מזהה משאב",
    "dialogTips": "טיפים",
    "theAuthorizationIsDeleted": "הסמכה הוסרה",
    "theBindingIsSuccessful": "הקשירה בוצעה בהצלחה",
    "theUnbindingIsSuccessful": "הסרת הקשירה בוצעה בהצלחה",
    "unbindingFailed": "הסרת הקשירה נכשלה",
    "theUnbindingHasBeenUnbound": "הסרת הקשירה בוטלה",
    "continueUnbinding": "סנכרון Outlook יעצר וכל האירועים הקרובים ימחקו. להמשיך בהסרת הקשירה?",
    "areYouSureAboutUnbinding": "כל אירועי Outlook הקרובים ימחקו והסנכרון יעצור. פעולה זו אינה ניתנת לביטול. לאשר הסרת קשירה?",
    "UnbindNotSynchronized": "לאחר הקשירה, אירועי Outlook חדשים עבור חדר זה יסונכרנו אוטומטית (אירועים קודמים לא יסונכרנו)",
    "unbinding": "הסר קשירה",
    "bindUnableToSelect": "כבר קשור, לא ניתן לבחור",
    "permissAThird": "אנא הסמך כדי לקשור משאבים של צד שלישי",
    "resourceMailbox": "אימייל המשאב:",
    "PleasecheckID": "הסמכה נכשלה! בדוק אם מזהה הדייר, מזהה האפליקציה וסוד הלקוח נכונים.",
    "Waitingforauthorization": "ממתין לאישור...",
    "Pleasecompletetheauthorization": "דף ההתחברות ל-Microsoft 365 נפתח. אנא התחבר עם חשבון מנהל כדי להשלים את האישור.",
    "pleaseEnterTheTenantID": "אנא הזן מזהה דייר",
    "pleaseEnterTheClientID": "אנא הזן מזהה אפליקציה",
    "pleaseEnterTheClientSecret": "אנא הזן סוד לקוח",
    "Authorizationcompleted": "האישור הושלם",
    "Authorizelogin": "אשר התחברות ל-Microsoft 365",
    "ApplicationID": "מזהה דייר",
    "ClientID": "מזהה אפליקציה",
    "ClientSecret": "סוד לקוח",
    "registTipOne": "אנא עקוב אחר",
    "registTipTwo": "מדריך קשירה",
    "registTipThree": "השלים רישום אפליקציה והגדרות הרשאה ב-Azure לפני מילוי השדות למטה.",
    "MicrosoftDescribe": "בקשר ל-Microsoft 365, פגישות שנקבעו ב-Outlook/Teams יסונכרנו אוטומטית ל-Q-NEX Console ו-Room Scheduler.",
    "Addcalendarservice": "הגדרות סנכרון לוח שנה",
    "Lasttimesynchronization": "שעת הסנכרון האחרונה",
    "Allocated": "שויך",
    "Total": "סה\"כ",
    "Conferenceroomresources": "משאב חדר ישיבות",
    "Bindingtime": "זמן קשירה",
    "Bindtheplatform": "פלטפורמת קשירה",
    "Synchronousstate": "סטטוס סנכרון",
    "Organizationname": "שם הארגון",
    "Bindthirdpartycalendar": "קשר לוח שנה של צד שלישי",
    "TenantIDTip": "מזהה ייחודי ב-Azure AD",
    "ApplicationIDTip": "מזהה אפליקציה שנרשם ב-Azure",
    "ApplicationSecretTip": "סוד לקוח שנוצר ב-Azure לאימות"
  },
  "meetingManager": {
    IdleDisplayTextTable: 'טקסט תצוגה במצב לא פעיל',
    IdleDisplayText: 'טקסט תצוגה במצב לא פעיל:',
    IdleDisplayTextContent: 'הטקסט המוצג כאשר החדר ריק (ברירת מחדל: "פנוי")',

    duplicateMeetingRoomName: 'שם חדר הישיבות כבר קיים',
    duplicateMeetingRoomNameContent: 'חדר ישיבות בשם "{duplicate_content}" כבר קיים. נא להזין שם אחר.',
    "NumberOfRoomPanels": "מספר פאנלים של חדר",
    "Thecurrentterminalhasbeenboundtoanotherorganization": "הטרמינל הנוכחי כבר קשור לארגון אחר.",
    "theTerminalNameOrIDIsDuplicated": "שם הפאנל או המזהה זהה",
    theRoomNameOrIDIsDuplicated: 'שם חדר הישיבות או המיקום כבר קיימים.',
    "AddMeetingRoom": "הוסף חדר ישיבות",
    "EditMeetingRoom": "ערוך חדר ישיבות",
    "MeetingRoomName": "שם חדר הישיבות:",
    "Location": "מיקום:",
    "ReservationApproval": "אישור הזמנה:",
    "ApprovalListYes": "כן",
    "ApprovalListNo": "לא",
    "Capacity": "קיבולת:",
    "RoomStatus": "מצב החדר:",
    "BindRoomDisplay": "קשור לפאנל חדר:",
    "meeting_btnAdd": "הוסף",
    "meeting_btnEdit": "ערוך",
    "meeting_btnBind": "קשור למכשיר",
    "meeting_btnDel": "מחק",
    "meeting_tableRoomName": "שם חדר הישיבות",
    "meeting_tableRoomPlace": "מיקום",
    "meeting_tableAppointmentApproval": "אישור הזמנה",
    "meeting_tableCapacityForPeople": "קיבולת",
    "meeting_tableMeetingRoomStatus": "מצב החדר",
    "meeting_tableAvaliable": "זמין",
    "meeting_tableOutofService": "מחוץ לשירות",
    "meeting_tableDoorBind": "קשור לדלת",
    "meeting_tableBindNPS": "קשור ל-NPS",
    "meeting_tableActions": "פעולות",
    "door_theNameOfTheTerminal": "שם פאנל:",
    "door_deviceID": "מזהה פאנל:",
    "door_Wallpaper": "טפט:",
    "door_Wallpaper_text": "תמונה מומלצת: גודל 1280x800, בפורמט PNG",
    "door_bindAMeetingRoom": "קשור לחדר ישיבות:",
    "door_table_name": "שם פאנל",
    "door_table_deviceID": "מזהה פאנל",
    "door_table_status": "סטטוס",
    "door_table_ipAddress": "כתובת IP",
    "door_table_bindAMeetingRoom": "קשור לחדר ישיבות",
    "door_btnAdd": "הוסף",
    "door_btnBatchAdd": "הוסף בקבוצה",
    "door_btnEdit": "ערוך",
    "door_btnBatchEdit": "ערוך בקבוצה"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "הוספת קונפיגורציה",
    "configurationEditTitle": "עריכת קונפיגורציה",
    "dialogConfigName": "שם הקונפיגורציה",
    "selectNMPAndNDP": "מכשירים יעד",
    "powerControl": "בקרת חשמל",
    "executeCommand": "בצע",
    "tableConfigName": "שם הקונפיגורציה",
    "selectConfig": "אנא בחר קונפיגורציה"
  },
  "NPS": {
    "Relay": "ממסר",
    "RelaySettings": "הגדרות ממסר",
    "DevicePower": "בקרת חשמל למכשיר",
    "DeviceElevation": "בקרת גובה",
    "LinageWithNPSPower": "קישור עם חשמל NPS",
    "PresentationSwitch": "מתג מצגת",
    "Duplicate": "שכפול",
    "LinkagewithNPSPowe": "קישור עם חשמל NPS"
  },
  "PTZ": {
    "powerSupplyON": "הפעל כוח",
    "powerSupplyOFF": "כבה כוח",
    "LEFT": "שמאל",
    "RIGHT": "ימין",
    "UP": "מעלה",
    "DOWN": "מטה",
    "HOME": "בית",
    "ENLARGE": "הגדל",
    "REDUCTION": "הקטן",
    "StopMovement": "עצור תנועה",
    "STOP": "עצור זום",
    "FOCUS": "מיקוד",
    "SET_PRESETS0": "קבע פריסט 0",
    "SET_PRESETS1": "קבע פריסט 1",
    "SET_PRESETS2": "קבע פריסט 2",
    "SET_PRESETS3": "קבע פריסט 3",
    "SET_PRESETS4": "קבע פריסט 4",
    "SET_PRESETS5": "קבע פריסט 5",
    "SET_PRESETS6": "קבע פריסט 6",
    "SET_PRESETS7": "קבע פריסט 7",
    "SET_PRESETS8": "קבע פריסט 8",
    "SET_PRESETS9": "קבע פריסט 9",
    "USE_PRESETS0": "השתמש בפריסט 0",
    "USE_PRESETS1": "השתמש בפריסט 1",
    "USE_PRESETS2": "השתמש בפריסט 2",
    "USE_PRESETS3": "השתמש בפריסט 3",
    "USE_PRESETS4": "השתמש בפריסט 4",
    "USE_PRESETS5": "השתמש בפריסט 5",
    "USE_PRESETS6": "השתמש בפריסט 6",
    "USE_PRESETS7": "השתמש בפריסט 7",
    "USE_PRESETS8": "השתמש בפריסט 8",
    "USE_PRESETS9": "השתמש בפריסט 9"
  },
  "schedule": {
    "startLinkPowerStart": "הפעל כוח (קישור התחלה)",
    "startLinkPowerStop": "כבה כוח (קישור עצירה)",
    "dehumidification": "ייבוש",
    "airSupply": "אספקת אוויר",
    "masterControl": "שליטה ראשית",
    "powerSupply": "ספק כוח",
    "lockScreen": "נעילת מסך",
    "RecordingControl": "בקרת הקלטה",
    "RecordingControlSystem": "מערכת בקרת הקלטה",
    "LiquidCrystal": "תצוגה נוזלית",
    "projector": "פרוג'קטור",
    "othertype": "סוג אחר",
    "childLock": "נעילת ילדים",
    "energySaving": "חיסכון באנרגיה",
    "signalSourceSwitching": "החלפת מקור אות",
    "other": "אחר",
    "otherFunction": "פונקציה נוספת",
    "send": "שלח",
    "ON": "הפעל",
    "OFF": "כבה",
    "btnAddSchedule": "כפתור הוסף מתזמן",
    "EditSchedulelist": "ערוך רשימת מתזמנים",
    "AddSchedulelist": "הוסף רשימת מתזמנים",
    "RestoreSchedulelist": "שחזור רשימת מתזמנים",
    "btn": "כפתור",
    "btnNewList": "כפתור רשימה חדשה",
    "ListName": "שם רשימה",
    "Cannotquit": "לא ניתן לצאת",
    "NOCannotquit": "לא, לא ניתן לצאת",
    "ListValidityPeriod": "תקופת תוקף רשימה",
    "ListDescription": "תיאור רשימה",
    "currentSchedule": "מתזמן נוכחי",
    "historySchedule": "מתזמן היסטורי",
    "selectTime": "בחר זמן",
    "taskType": "סוג משימה",
    "selectBroadcasting": "בחר שידור",
    "selectDeviveControl": "בחר בקרת מכשיר",
    "newSchedule": "מתזמן חדש",
    "newChecklist": "רשימת בדיקה חדשה",
    "titleStatus": "כותרת סטטוס",
    "titleType": "כותרת סוג",
    "titleStartTime": "כותרת שעת התחלה",
    "titleEndTime": "כותרת שעת סיום",
    "titleRepeat": "כותרת חזרה",
    "titleName": "כותרת שם",
    "titleAction": "כותרת פעולה",
    "tableEnabled": "מופעל",
    "tablePaused": "מושהה",
    "tableEdit": "ערוך",
    "tableDelete": "מחק",
    "tableVolumeEdit": "עוצמת שידור",
    "tableBroadcastTitle": "כותרת",
    "tableBroadcastContent": "תוכן",
    "tableBroadcastList": "רשימה",
    "tableBroadcast": "כפייה",
    "btnRemoveCompletely": "הסר לחלוטין",
    "btnEnabled": "מופעל",
    "btnPaused": "מושהה",
    "btnDelete": "מחק",
    "repeat0": "שני",
    "repeat1": "שלישי",
    "repeat2": "רביעי",
    "repeat3": "חמישי",
    "repeat4": "שישי",
    "repeat5": "שבת",
    "repeat6": "ראשון",
    "dialogTitleAdd": "משימת בקרת מכשיר חדשה",
    "dialogTitleEdit": "ערוך משימת בקרת מכשיר",
    "newBroadcastingSchedule": "משימת שידור חדשה",
    "editBroadcastingSchedule": "ערוך משימת שידור",
    "chooseDevice": "בחר מכשיר",
    "timeSetting": "הגדרת זמן",
    "controlBroadcasting": "אפשרות שידור",
    "controlOption": "אפשרות בקרה",
    "scheduleName": "שם משימה:",
    "destination": "יעד",
    "timeTilte": "זמן",
    "repeatTitle": "חזור על פעולה",
    "dialogRepeat0": "שני",
    "dialogRepeat1": "שלישי",
    "dialogRepeat2": "רביעי",
    "dialogRepeat3": "חמישי",
    "dialogRepeat4": "שישי",
    "dialogRepeat5": "שבת",
    "dialogRepeat6": "ראשון",
    "dialogOnceType": "פעם אחת",
    "dialogRepeatType": "חזור על פעולה",
    "mainPower": "כוח ראשי",
    "powerControl": "בקרת חשמל",
    "tableDisplayInputSwitch": "החלפת קלט תצוגה",
    "tableAirConditioning": "מזגן",
    "tableProjectionScreen": "מסך הקרנה",
    "tableElectronicLock": "נעילה חשמלית",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "החלפת קלט תצוגה",
    "speakerVolume": "עוצמת רמקול",
    "MICVolume": "עוצמת מיקרופון",
    "ProjectionScreen": "מסך הקרנה",
    "ElectronicLock": "נעילה חשמלית",
    "AirConditioning": "מזגן",
    "AirConditioningPower": "כוח",
    "AirConditioningModel": "דגם",
    "AirConditioningTEMP": "טמפרטורה",
    "AirConditioningFanSpeed": "מהירות מאוורר",
    "OPEN": "פתח",
    "CLOSE": "סגור",
    "UP": "למעלה",
    "DOWN": "למטה",
    "PowerOFF": "כבוי",
    "PowerON": "פועל",
    "ModelAuto": "אוטו",
    "ModelCool": "קירור",
    "ModelHeat": "חימום",
    "ModelAir": "צד אוויר",
    "TEMPLow": "נמוך",
    "TEMPMiddle": "בינוני",
    "TEMPHigh": "גבוה",
    "btnSave": "שמור",
    "btnNext": "הבא",
    "StartTime": "שעת התחלה",
    "StopTime": "שעת סיום",
    "Mandatory": "חובה",
    "Video": "וידאו ושמע",
    "Notification": "התראה",
    "btnFile": "בחר קובץ מדיה",
    "LastingTime": "משך זמן",
    "textTitle": "כותרת",
    "textContent": "תוכן",
    "textTitleLetters": "פחות מ-60 תווים",
    "textContentLetters": "פחות מ-320 תווים",
    "CannotquitYES": "כן",
    "CannotquitNo": "לא",
    "YES": "כן",
    "No": "לא",
    "delTitleContent": "האם אתה בטוח שברצונך למחוק את המתזמן הזה?",
    "delTitleListContent": "המתזמן שנמחק יעבור לרשימת ההיסטוריה וניתן לשחזור",
    "deleListTitle": "למחוק מתזמן?",
    "delTitleListContent1": "מחיקת המתזמן תגרום למחיקת המשימות הקשורות לו, נא לאשר.",
    "deleListTitle1": "האם אתה בטוח שברצונך למחוק את המתזמן הזה?",
    "delTitle": "למחוק?",
    "btnConfirm": "אשר",
    "coxAll": "הכול",
    "coxBroadcasting": "שידור",
    "coxDeviveControl": "בקרת מכשיר",
    "rdMandatory": "כן",
    "noRdMandatory": "לא",
    "startDate": "תאריך התחלה",
    "endedDate": "תאריך סיום",
    "or": "-",
    "broadcastingType": "סוג",
    "ChooseTime": "בחר זמן",
    "ChooseDate": "בחר תאריך",
    "newScheduleList": "מתזמן חדש",
    "editScheduleList": "ערוך מתזמן",
    "listName": "שם",
    "listValidityPeriod": "תקופת תוקף",
    "listDescription": "תיאור",
    "cancel": "ביטול",
    "confirm": "אשר",
    "save": "שמור",
    "addSuccess": "הוספה הצליחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "restoreSuccess": "רשימת המתזמנים שוחזרה בהצלחה",
    "restoreError": "שחזור רשימת המתזמנים נכשל",
    "restoreTitleContent": "הזמן הזה מתנגש עם זמן המתזמן ברשימה, נא לבחור שוב",
    "Enabled": "מופעל",
    "Paused": "מושהה",
    "Title": "כותרת:",
    "Content": "תוכן:",
    "errorScheduleNameRequired": "יש למלא שם משימה",
    "errorDeviceRequired": "נא לבחור את המכשיר היעד",
    "deleTitle": "האם אתה בטוח שברצונך למחוק את המשימה הזו?",
    "loopList": "רשימת לולאה",
    "errorPleaseDateRange": "נא לבחור טווח תאריכים",
    "addError_2009": "שם מתזמן כפול",
    "conflicts": "זמן המשימה מתנגש עם הבאים:",
    "Pleaseagain": "נא להזין שוב",
    "errorScheduleName": "שם המשימה",
    "errorListName": "שם המתזמן",
    "today": "היום",
    "yesterday": "אתמול",
    "thisWeek": "השבוע",
    "lastWeek": "שבוע שעבר",
    "lastMonth": "חודש שעבר",
    "thisMonth": "חודש זה",
    "times": "פעמים",
    "TimeConflicts": "התנגשויות זמן",
    "editError_2006": "לא נמצא מכשיר",
    "editError_2010": "שם משימה כפול",
    "ListTimeExpired": "זמן המתזמן פג תוקף, נא לבחור שוב",
    "TimeExpired": "הזמן פג תוקף",
    "ControlOption": "אפשרות הבקרה חסרה",
    "Pleaseleastone": "נא לבחור לפחות אפשרות בקרה אחת",
    "Enter": "הזן",
    "TitleFilled": "יש למלא כותרת",
    "ContentFilled": "יש למלא תוכן",
    "PleaseMediaFile": "נא לבחור קובץ מדיה",
    "PleaseSchedule": "נא לבחור משימה",
    "delTitleScheduleContent": "המשימה שנמחקה אינה ניתנת לשחזור",
    "deleTitleSchedule": "האם אתה בטוח שברצונך למחוק את המשימה הזו?",
    "deleteScheduleTitle": "נא לבחור את המשימה למחיקה",
    "PleaseFillColumn": "נא למלא את שם המתזמן",
    "PleaseDate": "נא לבחור את התאריך",
    "Previous": "קודם",
    "RemoteControl": "שלט רחוק",
    "taskhasexpired": "המשימה הזו פג תוקף, נא ליצור קשר עם היוצר לעדכון זמן",
    "execute": "בצע",
    "broadcastingList": "רשימת שידור",
    "volumeSuccess": "הגדרת עוצמה הצליחה",
    "volumeFailed": "הגדרת עוצמה נכשלה"
  },
  "Automation": {
    "nameDuplicate": "שם המשימה האוטומטית כפול",
    "Automation": "אוטומציה",
    "if": "אם:",
    "ifContent": "סעיף 'IF' מאפשר לך להגדיר תנאים על סמך נתוני חיישנים. בחר חיישן וציין תנאים כגון 'טמפרטורה > 26°C'.",
    "then": "אז:",
    "thenContent": "סעיף 'THEN' מאפשר לבחור מכשירים ולהגדיר עבורם פעולות. בחר מכשירים כמו NMP1, NMP2 וציין פעולות כמו 'הפעל + קירור' למזגנים.",
    "btnDelete": "מחק",
    "Add": "הוסף",
    "taskName": "שם משימה",
    "dialogTaskName": "שם המשימה:",
    "Statue": "סטטוס",
    "DevicesApplied": "מכשירים שהוחלו עליהם",
    "Operation": "פעולה",
    "AirConditioningPower": "כוח",
    "AirConditioningModel": "דגם",
    "AirConditioningFanSpeed": "מהירות מאוורר",
    "bold": "נפנוף",
    "selectTask": "נא לבחור משימה",
    "autoTaskAdd": "הוסף משימת אוטומציה",
    "autoTaskEdit": "ערוך משימת אוטומציה",
    "Destination": "יעד",
    "selectConditions": "נא לציין את הפעולה שברצונך לבצע.",
    "selectDestination": "נא לבחור את מכשיר(י) NMP היעד, ולאחר מכן לציין את הפעולה שברצונך לבצע",
    "AirConditioningTEMP": "טמפרטורה",
    "AirConditioningHumidness": "לחות",
    "noData": "טרם נוספו משימות. לחץ על כפתור \"הוסף\" כדי להוסיף משימות."
  },
  "rs232Translation": {
    "reliveBinding": "בטל קשירה",
    "RELIVEBINDING": "בטל קשירה",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "שם CBX אינו יכול להיות ריק",
    "BrandNoNull": "המותג אינו יכול להיות ריק",
    "ModelNoNull": "הדגם אינו יכול להיות ריק",
    "AcNoNull": "בקרת מזגן אינה יכולה להיות ריקה",
    "RcNoNull": "שלט רחוק אינו יכול להיות ריק"
  },
  "route": {
    "customize": "התאמה אישית",
    "InputSourcesLinkage": "קישוריות מקורות קלט",
    "Automation": "אוטומציה",
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "organizationMge": "קבוצות",
    "userMge": "משתמשים",
    "authorityMge": "הרשאות",
    "roleMge": "תפקידים",
    "equipmentMge": "מכשירים",
    "workstationMge": "שרת מדיה",
    "cloudDiskMge": "ניהול אחסון",
    "operationLog": "יומן פעולות",
    "setting": "הגדרות",
    "resourceMge": "ניהול משאבים",
    "storageMge": "ניהול אחסון",
    "interfaceRename": "שינוי שם ממשק",
    "processorManager": "מנהל מעבד",
    "projectorCode": "ניהול קוד סידורי",
    "projectorCodeSetting": "הגדרות קוד סידורי",
    "RepairLog": "יומן תיקונים",
    "remoteControl": "קוד שלט רחוק",
    "acCode": "קוד בקרת מזגן",
    "cardMge": "כרטיסים",
    "cardLog": "יומן שימוש בכרטיסים",
    "cardManager": "מנהל כרטיסים",
    "meetingManager": "פגישות",
    "meetingRoomManager": "ניהול חדרים",
    "meetingDoorManager": "ניהול לוחות"
  },
  "navbar": {
    "logOut": "התנתקות",
    "dashboard": "לוח מחוונים",
    "screenfull": "מסך מלא",
    "language": "שפה",
    "userConsole": "קונסולת Q-NEX",
    "BackTianwa": "חזרה ל-Tianwa"
  },
  "feedback": {
    "Feedback": "משוב",
    "email": "אנא השאר את כתובת האימייל שלך לצורך המשוב שלנו.",
    "content": "ברוכים הבאים והעבר הודעות לשיפור המוצרים שלנו. תודה על ההערות שלך.",
    "submit": "שלח",
    "emailNoEmpty": "האימייל לא יכול להיות ריק",
    "emailTrueRule": "אנא הזן פורמט אימייל תקין",
    "contentNoEmpty": "התוכן לא יכול להיות ריק",
    "feedbackSuccess": "המשוב הצליח",
    "feedbackFailed": "המשוב נכשל",
    "emailNoChinese": "תיבת הדואר אינה יכולה להכיל תווים סיניים",
    "emailLength": "באורך של 5 עד 100 תווים",
    "GroupNameLength": "באורך של 1 עד 20 תווים",
    "emailSpecialString": "תיבת קלט זו אינה יכולה להכיל מחרוזות מיוחדות"
  },
  "login": {
    "title": "ברוך הבא",
    "logIn": "התחברות",
    "username": "שם משתמש",
    "password": "סיסמה",
    "any": "אופציונלי",
    "thirdparty": "או התחבר עם",
    "thirdpartyTips": "לא ניתן לדמות במחשב המקומי, אנא שלב עם הסימולציה העסקית שלך!!!",
    "placeholder": "[\n  \"שם משתמש\",\n  \"סיסמה\",\n  \"קוד אימות\"\n]",
    "userNameTitle": "שם המשתמש שגוי!",
    "forget": "שכחתם?",
    "loginTitle0": "התחברת בהצלחה!",
    "loginTitle1000": "שם המשתמש או הסיסמה שגויים!",
    "loginTitle1001": "יש למלא שם משתמש וסיסמה!",
    "loginTitle1002": "יש למלא קוד אימות!",
    "loginTitle1003": "סטטוס המשתמש לא חוקי, ההתחברות נכשלה!",
    "loginTitle1004": "שגיאת קוד אימות!",
    "loginTitle1005": "לא מחובר, אנא התחבר קודם!",
    "loginTitleUserName": "יש למלא שם משתמש!",
    "loginTitlePwd": "יש למלא סיסמה!",
    "loginTitleVercode": "יש למלא קוד אימות!",
    "errorLogin": "למשתמש אין זכויות מספיקות, לא ניתן להתחבר!",
    "titleLoginNameFormat": "חייב להכיל תווים בלבד, או תווים ומספרים."
  },
  "organizationMge": {
    "CanTDragTop": "לא ניתן להעביר לשורש",
    "prefixCannotBeEmpty": "קידומת חשבון המנהל העליון לא יכולה להיות ריקה",
    "enterEnglishLetters": "קידומת חשבון המנהל העליון יכולה לכלול רק אותיות אנגליות ומספרים",
    "dateNotSelected": "תאריך תחילת תוקף שירות הזרמת המדיה לא נבחר",
    "btnAddChild": "הוסף כפוף",
    "btnAddSibling": "הוסף מקביל",
    "title": "טיפ:",
    "againTitle": "אנא אשר שוב:",
    "sort": "מיון:",
    "realName": "שם אמיתי:",
    "titleShooleRq": "שדה זה חובה",
    "titleShooleNub": "פחות מ-100 תווים",
    "schoolName": "שם קבוצה:",
    "type": "סוג קבוצה:",
    "accountPrefix": "חשבון מנהל:",
    "organization": "מפיץ",
    "terminalMechanism": "משתמש קצה",
    "equipmentNum": "מספר מכשיר:",
    "organizationNum": "מספר קבוצת מסופים:",
    "adminName": "חשבון מנהל:",
    "adminPwd": "סיסמת מנהל:",
    "edit": "עריכה",
    "add": "הוסף",
    "del": "מחק",
    "addSuccess": "הוספה הצליחה",
    "addError": "הוספה נכשלה!",
    "editSuccess": "שונה בהצלחה",
    "editError": "שינוי נכשל!",
    "delSuccess": "מחיקה הצליחה!",
    "delWarn": "לא ניתן למחוק קבוצה זו עם מכשירים קשורים",
    "delError": "מחיקה נכשלה!",
    "cancel": "ביטול",
    "confirm": "אישור",
    "save": "שמור",
    "TrialWorkstation": "כעת אתם במצב ניסיון, שניתן לדחוף שידור והזרמה חיה ל-3 מסופים בלבד.",
    "Normal": "רגיל",
    "NormalWorkstation": "תקופת התוקף של שירות הזרמת המדיה היא מ-",
    "to": "עד",
    "Advent": "התחלה  ",
    "AdventWorkstationOne": "שירות ההזרמה יפוג ב-",
    "AdventWorkstationTwo": "אנא פנה לסוכן שלך לחידוש בזמן לשימוש רגיל.  ",
    "Expired": "פג תוקף  ",
    "ExpiredWorkstation": "שירות ההזרמה פג תוקף, אנא פנה לסוכן שלך לחידוש.  ",
    "admin": "מנהל:  ",
    "serviceState": "שירות מדיה להזרים:  ",
    "serviceStateLIST": "שירות מדיה להזרים  ",
    "ValidityPeriod": "תקופת תוקף:  ",
    "ValidityPeriodLIST": "תקופת תוקף  ",
    "Trial": "ניסיון  ",
    "Permanent": "קבוע  ",
    "AnnualBilling": "חיוב שנתי  ",
    "mediaValidityPeriod": "תקופת תוקף:  ",
    "mediaValidityPeriodLIST": "תקופת תוקף  ",
    "contactInformation": "פרטי קשר (להודעה על חידוש שירות ההזרמה)  ",
    "company": "שם חברה:  ",
    "email": "אימייל:  ",
    "phone": "טלפון:  ",
    "StartDate": "תאריך התחלה  ",
    "EndDate": "תאריך סיום",
    "To": "עד",
    "TerminalName": "שם משתמש קצה  ",
    "Competence": "מנהל  ",
    "operate": "הפעלה  ",
    "statusFilter": "סינון מצב  ",
    "disableStreaming": "האם אתה בטוח שברצונך להשבית את שירות ההזרמה?  ",
    "enableStreaming": "האם אתה בטוח שברצונך להפעיל את שירות ההזרמה?  ",
    "disableStreamingContent": "כאשר שירות ההזרמה מושבת, הקבוצה לא תוכל להשתמש בפונקציות הקשורות לשידור והזרמה חיה.  ",
    "enableStreamingContent": "אנא עדכן את תקופת התוקף עבור קבוצות עם שירות הזרמה שפג תוקפן.  ",
    "search": "הזן שם ארגון  ",
    "optionsYearZero": "אנא בחר  ",
    "optionsYearOne": "שנה אחת  ",
    "optionsYearTwo": "שנתיים  ",
    "optionsYearThree": "שלוש שנים  ",
    "dialogName": "שם:  ",
    "detTitle": "מחיקת הקבוצה תגרום למחיקת כל התוכן שבתוכה גם כן.  ",
    "groupDelTitle": "האם אתה בטוח שברצונך למחוק קבוצה זו?  ",
    "delTitle": "מחיקה?  ",
    "delTitleContent": "התוכן שנבחר יימחק מהמסד הנתונים. פעולה זו אינה ניתנת לביטול. האם ברצונך להמשיך?  ",
    "delCancelButton": "ביטול  ",
    "delConfirmButton": "אישור  ",
    "copySuccess": "התוכן הועתק ללוח הגזירים.  ",
    "copyError": "הדפדפן אינו תומך בהעתקה אוטומטית  ",
    "error1200": "שם קבוצה כפול  ",
    "error1201": "קבוצה או מזהה קבוצה כפול  ",
    "error1202": "חרג ממספר המכשירים שניתן לחבר  ",
    "error1203": "שם משתמש כפול  ",
    "error1204": "קיימת קבוצה עם אותו שם באותו רמה  ",
    "error1210": "אנא הזן את סיסמת המנהל  ",
    "warningGroup": "בחר קבוצה!  ",
    "warningTerminal": "קבוצת טרמינל לא יכולה ליצור תתי-קבוצות!  ",
    "account": "חשבון כפול  ",
    "titleOrganization": "הערה: קידומת החשבון מוגדרת ברמת הארגון. כל חשבונות המשתמשים בארגון זה ישתמשו באותה קידומת.",
    "all": "הכל"
  },
  "userMge": {
    "nickName": "כינוי  ",
    "contentWithBrand": "הזן את המותג או הדגם  ",
    "contentwithIp": "חיפוש לפי שם התקן או כתובת IP  ",
    "btnAdd": "משתמש חדש  ",
    "btnDelete": "מחק  ",
    "btnDownload": "הורדת תבנית  ",
    "btnImport": "ייבוא בכמות גדולה  ",
    "btnExport": "הורד  ",
    "btnDisable": "השבת  ",
    "btnEnable": "הפעל  ",
    "accountType": "סנן לפי תפקיד  ",
    "organizationName": "סנן לפי קבוצה  ",
    "content": "חיפוש  ",
    "systemAccount": "מזהה משתמש  ",
    "idCardNumber": "מספר עובד  ",
    "customizeAccount": "חשבון מותאם אישית  ",
    "userName": "שם  ",
    "licenseNum": "מספר רישיון  ",
    "phone": "טלפון  ",
    "email": "דוא\"ל  ",
    "role": "תפקיד  ",
    "status": "סטטוס  ",
    "affiliatedOrganization": "קבוצות  ",
    "roleTypeList1": "משתמש רגיל  ",
    "roleTypeList2": "סטודנט  ",
    "roleTypeList3": "הורה  ",
    "roleTypeList101": "מנהל סוכן  ",
    "roleTypeList102": "מנהל  ",
    "roleTypeList301": "מנהל על  ",
    "userStatus1": "פעיל  ",
    "userStatus2": "חסום  ",
    "userStatus3": "מחק  ",
    "operate": "פעולות  ",
    "dialogName": "כינוי:  ",
    "dialogUserName": "מזהה משתמש:  ",
    "dialogUserNameDefined": "שם משתמש:  ",
    "dialogPassword": "סיסמה:  ",
    "dialogID": "מספר עובד:  ",
    "dialogRole": "תפקיד:  ",
    "dialogEmail": "דוא\"ל:  ",
    "dialogPhone": "טלפון:  ",
    "dialogGroup": "קבוצה:  ",
    "addUser": "משתמש חדש  ",
    "editUser": "ערוך משתמש  ",
    "addSuccess": "הוספה הצליחה!  ",
    "addError": "הוספה נכשלה!  ",
    "editSuccess": "עריכה הצליחה!  ",
    "editError": "עריכה נכשלה!  ",
    "delSuccess": "מחיקה הצליחה!  ",
    "delError": "מחיקה נכשלה!  ",
    "cancel": "בטל  ",
    "confirm": "אישור  ",
    "save": "שמור  ",
    "tableDel": "מחק  ",
    "tableEdit": "ערוך  ",
    "selectRoles": "בחר תפקידים  ",
    "delTitle": "מחק?  ",
    "delTitleContent": "התוכן הנבחר יימחק ממסד הנתונים. פעולה זו אינה ניתנת לביטול. האם להמשיך?  ",
    "delCancelButton": "בטל  ",
    "delConfirmButton": "אישור  ",
    "titleRealNameRq": "שדה זה חייב להיות מלא  ",
    "titleRealNameFormat": "בחר שם משתמש המכיל רק אותיות ומספרים.  ",
    checkPasswordTitleTwo: 'אנא הגדר סיסמה של לפחות 6 תווים, הכוללת אותיות ומספרים. ניתן להשתמש בתווים מיוחדים (ללא הגבלה).',
    checkPasswordTitle: 'הסיסמה חייבת להכיל לפחות 6 תווים ואינה יכולה להיות רק מספרים',
    "titlePhoneFormat": "טלפון יכול לכלול רק מספרים, () + ו-  ",
    "phoneFilled": "טלפון חובה  ",
    "titleEmaileFormat": "פורמט דוא\"ל שגוי  ",
    "emaileFilled": "דוא\"ל חובה  ",
    "titlUserNameDefinedNub": "שם המשתמש אינו יכול לעלות על 30 תווים  ",
    "titlRealNameNub": "שם אינו יכול לעלות על 30 תווים  ",
    "titlRealNameField": "שם חובה  ",
    "thisPasswordField": "סיסמה חובה  ",
    "titlPassWordNub": "סיסמה חייבת להיות בין 6~30 תווים  ",
    "enableStatus": "הפעל משתמש  ",
    "stopStatus": "השבת משתמש  ",
    "enableContent": "האם אתה בטוח שברצונך להפעיל את המשתמש(ים)?  ",
    "stopContent": "האם אתה בטוח שברצונך להשבית את המשתמש(ים)?  ",
    "error1400": "שם המשתמש כבר קיים, נסה שוב  ",
    "error1401": "מזהה המשתמש כבר קיים והפעולה נכשלה!  ",
    "error1402": "הקבוצה אינה קיימת, הייבוא נכשל!  ",
    "error1403": "הנתונים שגויים  ",
    "error1404": "חסרות הרשאות  ",
    "selUser": "בחר משתמש!  ",
    "error1405": "נכשל בקבלת התפקיד  ",
    "error1406": "פורמט נתוני המשתמש המיובא שגוי  ",
    "error1407": "הדוא\"ל כבר קיים והפעולה נכשלה  ",
    "error1408": "הטלפון כבר קיים והפעולה נכשלה  ",
    "error1900": "הפרמטר שניגשת אליו ריק  ",
    "error1610": "אנא השתמש בתפקיד מנהל הקצה לביצוע פעולות קשורות  ",
    "errorOrgIdList": "הקבוצה אינה יכולה להיות ריקה!  ",
    "Bindsucceeded": "הקישור הצליח  ",
    "Bindfailed": "הקישור נכשל  ",
    "tableuserName": "שם משתמש  ",
    "titleDevice": "התקן  ",
    "bindDevice": "קישור התקן  ",
    "Bindcontrollable": "לקשר התקן שניתן לשליטה כעת?"
  },
  "devicesMge": {
    "mustChooseOne": "כאשר שלט חכם נבחר, חייב לבחור לפחות פקודת שליטה אחת  ",
    "customName": "שם מותאם אישית  ",
    "testAcCode": "בדוק קוד בקרה חדש למזגן  ",
    "Online": "באינטרנט  ",
    "Offline": "לא מחובר  ",
    "unBindConfirm": "אשר ביטול קישור סידורי  ",
    "unBindConfirm485": "אשר ביטול קישור RS485  ",
    "notYetBoundRS232": "ההתקן עדיין לא קשור לקוד סידורי. ניתן להוסיף דרך מכשירים > קוד בקרה סידורי  ",
    "RsFollowingFunctions": "ניתן להשיג את הפונקציות הבאות באמצעות קודים סידוריים:  ",
    "Unbind": "ביטול קישור  ",
    "Limit255": "שם הקובץ יכול להכיל עד 255 תווים  ",
    "clear": "נקה  ",
    "equipName": "שם המכשיר  ",
    "equipType": "סוג  ",
    "selectField": "בחר קובץ  ",
    "dialogTip": "*אם תיבת הקלט מימין ריקה, התוכן משמאל יוצג כברירת מחדל  ",
    "dialogTipSingle": "*אם למכשיר בודד אין שם, השתמש בשם \"ALL\"",
    "cantDelTemplateOne": "ה-CBX של",
    cantDelTemplateTwo: 'ה-CBX של ההתקן "{deviceName}" הוא תבנית. האם אתה בטוח שברצונך למחוק אותו?',
    "templateTitle": "החלפת תבנית",
    "templateContentOne": "שם ההתקן \"",
    "templateContentTwo": "\" נקבע כבר כתבנית CBX משותפת. האם אתה בטוח שברצונך להגדיר את ההתקן הנוכחי כתבנית?",
    "vcbNoTemplateNoSave": "לא ניתן לשמור ללא תבנית",
    "vcbAcControl": "בחר התקן A/C",
    "vcbRemoteControl": "בחר התקן שלט רחוק",
    "vcbPOWERControl": "שליטה על כוח",
    "vcbRS232Control": "שליטה בסריאלי",
    "vcbIRControl": "שליטה ב-IR",
    "vcbSetting": "הגדרת CBX",
    "editVcb": "עריכת CBX",
    "vcbName": "שם CBX",
    "iot": "שליטת CBX",
    "saveAsTemplate": "שמור כתבנית",
    saveAsTemplatereplenish: 'בחר מספר התקנים כדי להשתמש בתבנית זו במרכז הבקרה',
    "Upload": "העלה",
    "Select": "בחר",
    "InputDeviceID": "הזן מזהה מכשיר",
    "editNameTips": "* אם תיבת הקלט בצד ימין ריקה, התוכן בצד שמאל מוצג כברירת מחדל.",
    "_RS232A": "ממשק אחד",
    "_RS232B": "ממשק שני",
    "institutionDirectory": "ספריית מוסד",
    "projectionScreenLinkageSetting": "הגדרת בקרת מסך הקרנה",
    "screenLiftingLinkageDisplaySwitch": "בקרת מסך הקרנה וקישור עם תצוגה:",
    "stopLinkage": "כבוי (בקרת מסך הקרנה בנפרד)",
    "Enable": "פעיל (סנכרון בקרת מסך הקרנה ותצוגה)",
    "btnAddDevice": "הוסף מכשיר",
    "btnImportDevice": "ייבוא מכשירים בהמונים",
    "btnDel": "מחיקה",
    "btnEdit": "עריכה",
    "tableIpAddress": "כתובת IP",
    "MACAddress": "כתובת MAC",
    "firmwareVersion": "גרסת קושחה",
    "NA": "לא זמין",
    "tableDeviceName": "שם מכשיר",
    "tableStatus": "סטטוס",
    "tableVideoSwitch": "מתג וידאו",
    "tableAudio": "הפצת A/V",
    "tablePowerControl": "שליטה על כוח",
    "tableRS232": "שליטה בסריאלי",
    "tableIR": "שליטה ב-IR",
    "tableRFIDCard": "כרטיס IC",
    "tableControlPanel": "לוח שליטה",
    "tableOrganization": "קבוצות",
    "tableActions": "פעולות",
    "dialogAddTitle": "הוסף מכשיר",
    "dialogEditTitle": "עריכת מכשיר",
    "dialogBatchAddTitle": "הוספה המונית של מכשירים",
    "dialogBatchEditTitle": "עריכה המונית של מכשירים",
    "btnCancel": "ביטול",
    "Devices": "מכשירים:",
    "ProjectorCode": "קוד סריאלי:",
    "Group": "קבוצה:",
    "btnBatchAdd": "הוספה המונית",
    "delTitle": "מחיקה?",
    "delTitleContent": "הרכיבים שנבחרו יימחקו מהמאגר. תהליך זה בלתי הפיך. האם אתה בטוח שברצונך להמשיך?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אישור",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "content": "חיפוש",
    "cancel": "ביטול",
    "confirm": "אישור",
    "save": "שמור",
    "tableDel": "מחק",
    "tableEdit": "ערוך",
    "selectRoles": "בחר תפקידים",
    "selectType": "אנא בחר סוג",
    "selectDevices": "אנא בחר מכשיר",
    "titleRealNameRq": "שדה זה חובה",
    "titleRealNameNub": "פחות מ-100 תווים",
    "titlPassWordNub": "פחות מ-15 תווים",
    "error1900": "הפרמטר אליו ניגשת ריק",
    "error2000": "חרגת ממספר המכשירים המחוברים המקסימלי",
    "error2001": "קוד המכשיר המיובא שגוי או טרם הוזן למערכת",
    "error2002": "שם המכשיר שיובא כפול",
    "error2003": "מזהה המכשיר שיובא כבר בשימוש",
    "error2004": "שגיאת נתוני ייבוא",
    "error2005": "שם המותג או הדגם כפול למידע קיים במערכת; אנא שנה את שם המותג או הדגם",
    "error2008": "מכשיר זה כבר משויך לקבוצה אחרת",
    "notDevicesName": "שם המכשיר אינו יכול להיות ריק",
    "notDevicesNO": "מזהה המכשיר אינו יכול להיות ריק",
    "dialogDevicesName": "שם המכשיר:",
    "dialogDevicesID": "מזהה מכשיר:",
    "dialogProjectorCode": "קוד סידורי:",
    "dialogGroup": "קבוצה:",
    "dialogSel": "אנא בחר",
    "errorOrgIdList": "קבוצה אינה יכולה להיות ריקה!",
    "errorDevicesName": "שם המכשיר אינו יכול להיות ריק!",
    "errorDevicesNo": "מזהה המכשיר אינו יכול להיות ריק!",
    "dialogTiltleDevices": "מכשירים:",
    "uploadSuccess": "העלאה הצליחה",
    "addSuccess": "הוספה הצליחה",
    "ChooseGroups": "בחר קבוצות",
    "ChooseIcon": "בחר סמל",
    "dialogDevicesTitle": "הגדרות הפרמטר חלות על המכשירים הבאים",
    "backDevice": "חזור",
    "bootSetting": "אפשרויות הפעלה",
    "nmpOpenSetting": "הגדרות הפעלה",
    "npsOpenSetting": "הגדרות הפעלה",
    "nmpPowerSettings": "הגדרות חשמל",
    "npsPowerSettings": "הגדרות חשמל",
    "nmpInterfaceSettings": "הגדרות ממשק",
    "npsInterfaceSettings": "הגדרות ממשק",
    "nmpDefaultChannel": "הגדרות ערוץ ברירת מחדל",
    "nmpCloseSetting": "הגדרות כיבוי",
    "npsCloseSetting": "הגדרות כיבוי",
    "SwipeToStart": "הפעל נעילה (הקש כרטיס כדי לפתוח)",
    "ControlPanelToStart": "השבת נעילה (פעולה ללא הגבלה)",
    "Display": "תצוגה",
    "External": "חיצוני",
    "startingUpMethod": "הפעל/השבת נעילת לוח:",
    "startWith": "התחל עם:",
    "nmpstartWith": "סנכרן הפעלה:",
    "nmpcloseWith": "סנכרן כיבוי:",
    "RS232Tip": "כאשר החשמל הראשי כבוי, חמישה ממשקי סידורי כולל Serial ועד 4 CBX יקבלו את קוד הפקודה המתאים לכיבוי",
    "startPowerTip": "בעת הפעלה, כל המכשירים המחוברים ליציאות כוח CBX יופעלו.",
    "startAirTip": "בעת הפעלה, כל המזגנים המחוברים יופעלו דרך אותות IR מהמכשיר/CBX.",
    "startIrTip": "בעת הפעלה, פקודות (למשל גלילת מסך, כיבוי מקרן) יישלחו דרך אותות IR מהמכשיר/CBX.",
    "startRSTip": "בעת הפעלה, פקודות הפעלה יישלחו דרך יציאות Serial של המכשיר/CBX.",
    "CloseDisplayTip": "מכשירי תצוגה המחוברים ליציאות DISPLAY יכבו אוטומטית כאשר NDP/NMP ייכבה. הגדרה זו מנוהלת על ידי קושחה ואינה ניתנת לשינוי דרך תוכנה.",
    "CloseExternalTip": "מכשירים המחוברים ליציאות EXTERNAL יכבו אוטומטית כאשר NDP/NMP ייכבה. הגדרה זו מנוהלת על ידי קושחה ואינה ניתנת לשינוי דרך תוכנה.",
    "ClosePowerTip": "בעת כיבוי, כל המכשירים המחוברים ליציאות כוח CBX יכבו.",
    "CloseAirTip": "בעת כיבוי, כל המזגנים המחוברים יופעלו דרך אותות IR מהמכשיר/CBX.",
    "CloseIrTip": "בעת כיבוי, פקודות (למשל גלילת מסך, כיבוי מקרן) יישלחו דרך אותות IR מהמכשיר/CBX.",
    "CloseRSTip": "בעת כיבוי, פקודות כיבוי יישלחו דרך יציאות Serial של המכשיר/CBX.",
    "npsOpenRS232Tip": "בעת הפעלת החשמל הראשי, שני יציאות סידוריות של NPS יקבלו את קודי הפקודה המתאימים להפעלה.",
    "npsRS232Tip": "בעת כיבוי החשמל הראשי, שני ממשקי Serial של NPS יקבלו את קודי הפקודה המתאימים לכיבוי.",
    "useCardTip": "לאחר פתיחת נעילת כרטיס, כוח המכשירים יופעל אוטומטית.",
    "npsCardTip": "לאחר פתיחת נעילת כרטיס, החשמל הראשי של המכשירים יופעל אוטומטית.",
    "PowerOutageHandling": "טיפול בעת הפסקת חשמל",
    "PowerOutageHandTip": "כדי להמשיך לגשת במהלך הפסקות חשמל בלתי צפויות, בחר 'פתח בעת הפסקת חשמל'. אחרת, בחר 'נעל בעת הפסקת חשמל' כדי להגביל את הגישה",
    "acSetting": "הגדרת מיזוג",
    "ChooseType": "סוג מכשיר",
    "ChooseBrand": "בחר מותג",
    "ChooseModel": "בחר דגם",
    "btnConnectingTest": "בדיקת חיבור",
    "LockSetting": "הגדרת מנעול חשמלי",
    "ElectricLockType": "סוג מנעול חשמלי:",
    "PowerUNLOCK": "פתח בעת הפסקת חשמל",
    "PowerLOCK": "נעל בעת הפסקת חשמל",
    "none": "ללא",
    "oddParity": "פריטי אי-זוגי",
    "EvenParity": "פריטי זוגי",
    "LastSetting": "הגדרה אחרונה",
    "ElectricLockClosing": "סגירת מנעול חשמלי:",
    "manualSwitch": "מחליק ידני",
    "Auto": "אוטומטי (in",
    "projectorSetting": "בחירת מכשיר וקישור",
    "baudRate": "קצב שידור",
    "Parity": "פריטי זוגי/אי-זוגי",
    "ON": "הפעל",
    "OFF": "כבה",
    "Channel1": "ערוץ 1",
    "Channel2": "ערוץ 2",
    "PowerOffDelay": "עיכוב כיבוי",
    "second": "שניות",
    "DefaultChannel": "ערוץ ברירת מחדל",
    "HDMIA": "HDMI פלט A:",
    "HDMIB": "HDMI פלט B:",
    "HDMIC": "HDMI פלט C:",
    "btnSaveApply": "שמור והחל על...",
    "btnSave": "שמור",
    "btnCustomize": "מותאם אישית",
    "ACIsPowerTitle": "בדוק אם המיזוג פועל?",
    "ACIsPowerContent": "כבה את המיזוג לפני הבדיקה. אם אינו נדלק בהצלחה, ודא שהמותג והדגם נכונים.",
    "btnNextModel": "לא, בדוק את הדגם הבא",
    "btnYes": "כן",
    "errorConnecting": "בדיקת חיבור נכשלה",
    "hot": "חם",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "מנעול אלקטרוני",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AUDIOA": "HDMI out A",
    "_AUDIOB": "Audio IN 1",
    "_AUDIOC": "Audio IN 2",
    "_AIR": "מזגן",
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "הגדרת שליטה באמצעות IR",
    "acControlTitle": "בחר מכשיר A/C:",
    "acControlTitleNew": "מכשיר A/C",
    "intelligentControlTitle": "בחר מכשיר שלט רחוק:",
    "intelligentControlTitleNew": "מכשיר שלט רחוק",
    "btnACControlCode": "זיהוי קוד שליטה חדש למזגן",
    "btnAddRemoteControl": "קוד שלט רחוק חדש",
    "ACControlCodeTitle": "זיהוי קוד שליטה למזגן",
    "ACControlCodeseft1": "זיהוי קוד",
    "ACControlCodeseft2": "הוסף מידע",
    "btnStartIdentify": "התחל",
    "Identifysuccess": "זיהוי הצליח!",
    "BeingIdentify": "בניתוח...",
    "acBrand": "מותג מזגן",
    "acModel": "דגם מזגן",
    "IdentifyFailureTitle": "לא ניתן למצוא את הקוד",
    "IdentifyFailureContent": "הזיהוי נכשל, דגם זה אינו נתמך כרגע. נסה את השלט הרחוק",
    "btnTryAgain": "נסה שוב",
    "btnJump": "עבור לשלט הרחוק",
    "ACrideo": "מזגן",
    "ortherRideo": "מכשירים אחרים",
    "btnBack": "חזרה",
    "btnSortOut": "עבור לעריכה",
    "remoteControlSeft1": "בחר סוג מכשיר",
    "remoteControlSeft2": "למד קוד",
    "remoteControlSeft3": "הוסף מידע",
    "addRemoteControlError": "מצטער, לא ניתן ללמוד יותר קודים. אנא ערוך תחילה את קודי השלט הקיימים",
    "btnPrevious": "קודם",
    "btnNextStep": "הבא",
    "remoteControlErrorTitle": "הכשל בלימוד הקוד",
    "remoteControlErrorContent1": "1. משדר האינפרא-אדום אינו חסום",
    "remoteControlErrorContent2": "2. אין הפרעות אור חזקות סביב המקלט",
    "remoteControlErrorContent3": "3. המשדר מותקן כראוי",
    "remoteControlErrorContent4": "4. השלט עובד היטב",
    "deviceItem1": "מזגן",
    "deviceItem2": "מקרן",
    "deviceItem3": "טלוויזיה",
    "deviceItem4": "מאוורר",
    "deviceItem5": "אור",
    "deviceItem6": "אחרים",
    "deviceItem7": "לוח מגע אינטראקטיבי",
    "deviceItem8": "מערכת הקלטת הרצאות",
    "deviceItem9": "מצלמת PTZ",
    "RS232protocol": "פרוטוקול סידורי:",
    "btnRemoteControl": "התחל ללמוד",
    "BeingIdentify1": "בניתוח...",
    "Identifysuccess1": "הצלחה",
    "controllerType1": "מזגן",
    "controllerType2": "סידורי",
    "controllerType3": "טלוויזיה",
    "controllerType4": "מאוורר",
    "controllerType5": "אור",
    "controllerType9": "אחרים",
    "rqRemoteControlCode": "אנא הזן את שם קוד השלט",
    "rqBrand": "אנא הזן את מותג המזגן",
    "rqModel": "אנא הזן את דגם המזגן",
    "error2016": "שם השלט כבר קיים, אנא הזן שם אחר",
    "RS232Setting": "הגדרת קוד סידורי",
    "IR232Setting": "הגדרת IR",
    "SystemError": "שגיאת מערכת. נסה שוב",
    "conditionerCodeContent": "לא נמצא קוד מזגן, אנא נסה שוב",
    "remoteControlCodeContent": "לא נמצא קוד שלט רחוק, אנא נסה שוב",
    "btnRetry": "נסה שוב",
    "Bindusers": "קשירת משתמש",
    "tablebinduser": "קשירת משתמשים",
    "Refresh": "רענן",
    "Binduserlable": "לקשור את המשתמשים שיכולים לשלוט במכשיר כעת?",
    "SaveApplySuccessfully": "שמירה והחלה בהצלחה",
    "DeviceType": "סוג:",
    "tableDeviceType": "סוג",
    "empty": "ריק.",
    "sendCommand": "שלח מאוחר יותר",
    "enable": "הפעל",
    "disable": "השבת",
    "SYNCremoteControl": "סנכרן עם השלט",
    "analysisfailed": "הניתוח נכשל, אנא נסה שוב!",

    "CBX": {
      "powerSupplyON": "הפעלה",
      "powerSupplyOFF": "כיבוי",
      "powerVcrON": "התחל הקלטה",
      "powerVcrOFF": "עצור הקלטה",
      "lockScreenON": "נעילת מערכת",
      "lockScreenOFF": "שחרור נעילה",
      "childLockON": "נעילת ילדים פעילה",
      "childLockOFF": "נעילת ילדים לא פעילה",
      "energySavingON": "חיסכון באנרגיה פעיל",
      "energySaving": "חיסכון באנרגיה",
      "energySavingOFF": "חיסכון באנרגיה כבוי",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "רמקול",
      "brightAdjustment": "בהירות",
      "other": "תכונות נוספות...",
      "volumeExample": "לניצול מלא של מערכת ההקלטה דרושה פונקציונליות מלאה של RS232.",
      "functionCode": "פונקציה:",
      "Name": "שם:",
      "controlCode": "קוד בקרה:",
      "brand": "מותג:",
      "model": "דגם:",
      "errorBrandName": "המותג אינו יכול להיות ריק!",
      "errorModelName": "הדגם אינו יכול להיות ריק!"
    }
  },
  "roleMge": {
    "role1": "משתמש כללי",
    "role101": "מנהל סוכן",
    "role102": "מנהל",
    "role4": "תפקיד מותאם אישית",
    "roleNew": "תפקיד חדש",
    "btnAddRole": "הוסף תפקיד",
    "chooseUser": "בחר משתמש",
    "titleLevel": "רמת נכס השידור:",
    "titleSettings": "הגדרות הרשאה:",
    "btnSave": "שמור",
    "btnDelete": "מחק",
    "cancel": "ביטול",
    "confirm": "אשר",
    "save": "שמור",
    "addSuccess": "נוסף בהצלחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "V3_0_OrganizationManage": "ניהול קבוצות",
    "V3_0_UserManage": "ניהול משתמשים",
    "V3_0_DeviceManage": "ניהול מכשירים",
    "V3_0_CloudSpaceManage": "ניהול שטח ענן",
    "V3_0_OrganizationManage_View": "צפה",
    "V3_0_OrganizationManage_Edit": "ערוך",
    "V3_0_UserManage_View": "צפה",
    "V3_0_UserManage_Edit": "ערוך",
    "V3_0_DeviceManage_AddDevice": "הוסף מכשיר",
    "V3_0_DeviceManage_Operating": "פעולה",
    "V3_0_DeviceManage_Delete": "מחק",
    "V3_0_DeviceManage_Edit": "ערוך",
    "V3_0_CloudSpaceManage_PersonalManage": "ניהול ענן אישי",
    "V3_0_CloudSpaceManage_PublicManage": "ניהול ענן ציבורי",
    "V3_0_CloudSpaceManage_SpaceManage": "הקצאת שטח",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "פעולה",
    "V3_0_CloudSpaceManage_PersonalManage_View": "צפה",
    "V3_0_CloudSpaceManage_PublicManage_View": "צפה",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "העלה",
    "V3_0_CloudSpaceManage_PublicManage_Download": "הורד",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "מחק קובץ",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "ערוך תיקיה",
    "delTitle": "למחוק?",
    "delTitleContent": "התוכן שנבחר יימחק מהבסיס נתונים. פעולה זו אינה ניתנת לביטול. האם להמשיך?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אשר",
    "btnAdd": "הוסף תפקיד",
    "RoleName": "שם תפקיד:",
    "ManageRange": "תחום ניהול:",
    "ChooseUser": "בחר משתמש:",
    "PermissionSettings": "הגדרות הרשאה:",
    "BroadcastingPropertyLevel": "רמת נכס שידור",
    "ChooseGroups": "בחר קבוצות",
    "ChooseTheUser": "בחר משתמש",
    "deleleTitle": "התפקיד החדש לא נשמר. אם תעזוב, התפקיד יימחק. האם לעזוב?",
    "Error1601": "אין אפשרות להשתמש במנהל",
    "Error1602": "לא ניתן לקבל תפקיד הרשאה",
    "Error1603": "רק מנהלים יכולים לגשת לתכונות כאלה",
    "Error1604": "שם התפקיד אינו יכול להיות ריק",
    "Error1605": "הקבוצה אינה יכולה להיות ריקה",
    "Error1606": "התפקיד כבר קיים",
    "Error1607": "תפקיד מוגדר מערכת, אין אפשרות לשנות",
    "Error1608": "הגדרת תפקיד נכשלה",
    "Error1609": "תפקיד משתמש משותף של המערכת, אין אפשרות לשנות",
    "Error1610": "אנא השתמש בתפקיד מנהל קצה לביצוע פעולות קשורות",
    "Error1611": "אין הרשאות תפקיד קשורות"
  },
  "projectorDevicesMge": {
    "tipOne": "1. מלאו את שם הפונקציה וקוד הבקרה. דוגמאות לקוד בקרה משתמשות בפורמט HEX.",
    "tipTwo": "2. ממשק זה מיועד רק להגדרת פקודות סדרתיות להפעלה/כיבוי. אנא עברו אל 'ניהול מכשירים / מכשירים / פעולות / הגדרות חשמל' כדי להפעיל את הפונקציה.",
    "tipFunctionOne": "1. בחרו פונקציות נפוצות מהרשימה הנפתחת. הסמלים המתאימים יוצגו בממשק הבקרה הסדרתית של הפאנל החכם.",
    "tipFunctionTwo": "2. הפקודות 'POWER ON' ו-'POWER OFF' משמשות לקישור סדרתי להפעלה/כיבוי של המכשיר. דף זה מגדיר רק קודי בקרה. אנא עברו אל 'ניהול מכשירים / מכשירים / פעולות / הגדרות חשמל' כדי להפעיל את פונקציית הקישור.",
    "ListRS232functions": "רשימת פונקציות של שליטת סיריאל",
    "Customizefunctionlist": "התאמה אישית של רשימת הפונקציות",
    "btnAddProjectorCode": "הוסף קוד סיריאל",
    "btnDel": "מחק",
    "inputSeach": "חפש",
    "btnEdit": "ערוך",
    "cancel": "נקה",
    "confirm": "אשר",
    "tableName": "שם קוד",
    "tablersType": "סוג מכשיר:",
    "tablersTypeTable": "סוג מכשיר",
    "tableModel": "דגם",
    "tableBrand": "מותג",
    "tableActions": "פעולות",
    "dialogAddTitle": "הוסף קוד סיריאל",
    "dialogEditTitle": "ערוך קוד סיריאל",
    "brand": "שם מותג:",
    "model": "דגם:",
    "baudRate": "קצב בוד",
    "parity": "פריטי:",
    "powerOn": "הפעל",
    "powerOff": "כבה",
    "pgrInput1": "ערוץ 1",
    "pgbInput2": "ערוץ 2",
    "delTitle": "למחוק?",
    "delTitleContent": "התכנים שנבחרו יימחקו מהבסיס נתונים. פעולה זו אינה ניתנת לביטול. האם להמשיך?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אשר",
    "content": "חפש",
    "operate": "פעולות",
    "tableDel": "מחק",
    "tableEdit": "ערוך",
    "addSuccess": "נוסף בהצלחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "selectTitle": "אנא בחר סיריאל!",
    "selectCode": "בחר סיריאל",
    "none": "ללא",
    "oddParity": "פריטי אי זוגי",
    "EvenParity": "פריטי זוגי"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "ניהול קבוצות",
    "V3_0_UserManage": "ניהול משתמשים",
    "V3_0_DeviceManage": "ניהול מכשירים",
    "V3_0_CloudSpaceManage": "ניהול שטח ענן",
    "V3_0_OrganizationManage_View": "הצג",
    "V3_0_OrganizationManage_Edit": "ערוך",
    "V3_0_UserManage_View": "הצג",
    "V3_0_UserManage_Edit": "ערוך",
    "V3_0_DeviceManage_AddDevice": "הוסף מכשיר",
    "V3_0_DeviceManage_Operating": "הפעלה",
    "V3_0_DeviceManage_Delete": "מחק",
    "V3_0_DeviceManage_Edit": "ערוך",
    "V3_0_DeviceManage_RepairLog": "יומן תיקונים",
    "V3_0_CloudSpaceManage_PersonalManage": "ניהול ענן אישי",
    "V3_0_CloudSpaceManage_PublicManage": "ניהול ענן ציבורי",
    "V3_0_CloudSpaceManage_SpaceManage": "ניהול שטח ענן",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "הפעלה",
    "V3_0_CloudSpaceManage_PersonalManage_View": "הצג",
    "V3_0_CloudSpaceManage_PublicManage_View": "הצג",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "העלה",
    "V3_0_CloudSpaceManage_PublicManage_Download": "הורד",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "מחק",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "ערוך",
    "delTitle": "למחוק?",
    "delTitleContent": "הרכיבים שנבחרו יימחקו מהבסיס נתונים. פעולה זו אינה ניתנת לביטול. האם להמשיך?",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אשר",
    "content": "חפש",
    "operate": "פעולה",
    "tableDel": "מחק",
    "tableEdit": "ערוך",
    "addSuccess": "הוספה הצליחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "selectTitle": "אנא בחר סיריאל!"
  },
  "workstationMge": {
    "priorChoice": "העדפות שידור：",
    "SpeedPriority": "עדיפות מהירות",
    "SyncPriority": "עדיפות סנכרון פריימים",
    "SpeedPriorityTip": "לאחר שליחת הוראות שידור AV, מסופי Q-NEX יכולים לבצע את משימת ההשמעה בזמן חיץ קצר של כ-3–5 שניות. מומלץ בחום להשתמש בעדיפות מהירות כאשר שרת המדיה פועל ב-LAN.",
    "SyncPriorityTip": "לאחר שליחת הוראות שידור AV, מסופי Q-NEX יכולים לבצע את משימת ההשמעה בסנכרון עם זמן חיץ של כ-8–12 שניות.",
    "btnAddMedia": "הוסף שרת מדיה",
    "btnBack": "חזור",
    "tableMediaLibId": "מזהה שרת מדיה",
    "tableMediaLibName": "שם שרת מדיה",
    "tableState": "מצב רשת",
    "tableBindingUsers": "משתמשים מקושרים",
    "tableLiveAddress": "כתובת סטרימינג",
    "tableAddress": "כתובת שידור",
    "tableOperate": "פעולות",
    "tableDel": "מחק",
    "tableEdit": "ערוך",
    "titleMediaStation": "כתובת שידור",
    "titleLiveStation": "כתובת סטרימינג：",
    "radioPublic": "ציבורי",
    "radioPrivate": "פרטי",
    "btnSave": "שמור",
    "titleUsers": "משתמשים",
    "titleCanBe": "ניתן לקשר",
    "titleHaveBeen": "כבר מקושרים",
    "titleMore": "צריך להוסיף עוד?",
    "btnAdd": "הוסף",
    "content": "חיפוש",
    "tableName": "שם",
    "tableUserName": "שם משתמש",
    "operate": "פעולות",
    "affiliatedOrganization": "קבוצות",
    "dialogTitle": "הוסף שרת מדיה חדש",
    "dialogTitleEdit": "ערוך שרת מדיה חדש",
    "dialogItemName": "שם：",
    "dialogItemId": "ID：",
    "dialogItemIp": "כתובת שידור：",
    "titleSelectUsers": "בחר משתמשים",
    "selectMedia": "אנא בחר מדיה",
    "delTitle": "בטוח שברצונך למחוק?",
    "delMediaLibTitle": "אישור מחיקה？",
    "delTitleContent": "התוכן שנבחר יימחק מהמסד. פעולה זו אינה ניתנת לביטול. האם להמשיך?",
    "delTitleMediaLibContent": "פעולת המחיקה תגרום למחיקת נתונים רלוונטיים ולא ניתנת לביטול.",
    "delCancelButton": "ביטול",
    "delConfirmButton": "אישור",
    "selectDevices": "אנא בחר מכשירים",
    "selectUser": "אנא בחר משתמשים",
    "addUser": "הוסף משתמש",
    "editUser": "ערוך משתמש",
    "addSuccess": "הוספה הצליחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה הצליחה!",
    "delError": "מחיקה נכשלה!",
    "cancel": "ביטול",
    "confirm": "אישור",
    "save": "שמור",
    "error2500": "חורג ממספר המכשירים המרבי שניתן לחבר לעמדה הנוכחית.",
    "DeviceName": "שם מכשיר",
    "AssociatedUserManagement": "ניהול משתמשים משויך",
    "btnDel": "מחק",
    "errorMsgId": "לא נמצא מזהה זה",
    "LiveStreaming": "כתובת סטרימינג：",
    "NoFoundMediaId": "לא ניתן לקבל את מזהה שרת המדיה",
    "AlreadyConnectedOrg": "שרת המדיה כבר מקושר לארגון אחר",
    "AlreadyBoundMedia": "ארגון זה כבר קשור לשרת מדיה ואינו יכול לקשר נוסף",
    "DeleteSecondaryConfirmation": "לא ניתן לשחזר נתונים לאחר מחיקת שרת המדיה, אנא אשר שוב."
  },
  "cloudDiskMge": {
    "totalStorage": "סך כל האחסון",
    "GetMore": "קבל עוד",
    "StorageSpace": "שטח אחסון",
    "Adjustment": "התאמה",
    "moreSpace": "קבל עוד שטח אחסון",
    "PublicStorage": "אחסון ציבורי",
    "PublicStorageUsed": "אחסון ציבורי בשימוש",
    "PublicStorageLasted": "אחסון ציבורי נותר",
    "IndividualStorageUsed": "אחסון אישי בשימוש",
    "IndividualStorageLasted": "אחסון אישי נותר",
    "storageSpace": "התאמת שטח אחסון",
    "tableUserName": "שם משתמש",
    "tableUsedSpace": "שטח בשימוש",
    "tableAvailableSpace": "שטח זמין",
    "tableActiveTime": "זמן פעילות אחרון",
    "tableOperate": "פעולות",
    "cleanup": "הערה לניקוי",
    "IndividualStorageSpaceAdjustment": "התאמת שטח אחסון אישי",
    "titleTotal": "סך הכל",
    "PublicDisk": "ענן ציבורי",
    "IndividualDisk": "ענן אישי",
    "PerUser": "לכל משתמש",
    "UsersInTotal": "סך המשתמשים",
    "cancel": "ביטול",
    "confirm": "אישור",
    "save": "שמור",
    "addSuccess": "הוספה בוצעה בהצלחה!",
    "addError": "הוספה נכשלה!",
    "editSuccess": "עריכה בוצעה בהצלחה!",
    "editError": "עריכה נכשלה!",
    "delSuccess": "מחיקה בוצעה בהצלחה!",
    "delError": "מחיקה נכשלה!",
    "error3000": "הפעולה נכשלה כי סך כל האחסון הועבר מעבר למגבלה.",
    "error3003": "פעולה נכשלה, נא לבדוק אם שרת המדיה הוגדר.",
    "IndividualStorage": "אחסון אישי",
    "NoteToCleanup": "הערה לניקוי",
    "updatePersonalSuccess": "שטח אחסון הענן שלך מתמלא, נא לנקות בזמן",
    "updatePersonalSuccess1": "שונה ונשמר בהצלחה",
    "storageUsage": "שימוש באחסון אישי",
    "bindIndividualstorage": "משתמשים המורשים לאחסון ענן אישי",
    "UserIndividualstorage": "משתמשים שכבר הוגדר להם אחסון ענן אישי",
    "Notificationsuccessfully": "הודעה נשלחה בהצלחה",
    "Notificationfailed": "הודעה נכשלה",
    "tableName": "שם",
    "userID": "מספר משתמש"
  },
  "dashboard": {
    "exportPdf": "ייצא PDF",
    "or": "-",
    "warrantyCompletionRate": "אחוזי סיום תיקונים",
    "frequencyOfEachModule": "אחוז התיקון של כל מודול פונקציונלי",
    "repairHandling": "סטטוס טיפול בתיקונים",
    "sourceSwitchInput": "מתג קלט",
    "micVol": "עוצמת מיקרופון",
    "volumeSpeaker": "עוצמת רמקול",
    "airAonditioner": "מזגן",
    "Curtain": "מסך מקרן",
    "remoteControlIntelligent": "שלט רחוק",
    "RS232Control": "בקרת סידורי",
    "lockElectronic": "מנעולים אלקטרוניים",
    "Repairreportcompleted": "תוקן",
    "Totalnumberofrepairsreported": "סך כל התיקונים",
    "Warrantycompletionrate": "אחוזי סיום תיקונים",
    "startDate": "תאריך התחלה",
    "endDate": "תאריך סיום",
    "year": "שנה",
    "month": "חודש",
    "dayTian": "יום",
    "placeholderDate": "בחר תאריך",
    "placeholderDateTime": "בחר שעה",
    "devicesNub": "מכשירים",
    "userNub": "משתמשים",
    "powerNub": "חשמל (KW/H)",
    "storageUsed": "שטח אחסון בשימוש (%)",
    "userLoginDevice": "תקופת פעילות כניסת משתמש",
    "devicePowerConsumption": "צריכת חשמל יומית של כל המכשירים",
    "externalDeviceUsageTime": "שימוש במכשירים חיצוניים",
    "equipmentRunningTime": "שימוש במכשירי מסוף",
    "cloudStorageSpace": "שימוש אחסון",
    "powerConsumptionPort": "צריכת חשמל בכל יציאת כוח",
    "mostPopularFile": "קובץ פופולרי ביותר",
    "commonFunctions": "פונקציות נפוצות",
    "commonlyUsed": "שיטת שידור נפוצה",
    "fileName": "שם קובץ",
    "usageCount": "מספר שימושים",
    "electricityConsumption": "צריכת חשמל",
    "publicStorageUsed": "שימוש אחסון ציבורי",
    "publicStorageLasted": "אחסון ציבורי נותר",
    "individualStorageUsed": "שימוש אחסון אישי",
    "individualStorageLasted": "אחסון אישי נותר",
    "notification": "הודעה",
    "audioBroadcast": "שידור אודיו",
    "videoBroadcast": "שידור וידאו",
    "ac": "מזגן",
    "hDMISwitch": "מחליף HDMI",
    "powerControl": "בקרת כוח",
    "powercontrol": "בקרת כוח",
    "Lock": "נעילה",
    "volumeAdjust": "כיווץ עוצמה",
    "projectionScreen": "מסך הקרנה",
    "today": "היום",
    "yesterday": "אתמול",
    "thisWeek": "השבוע",
    "lastWeek": "שבוע שעבר",
    "lastMonth": "חודש שעבר",
    "thisMonth": "חודש זה",
    "times": "מספר פעמים",
    "usage": "מספר שימושים",
    "eachrTitle": "דקות",
    "total": "סה\"כ",
    "NMPSystemissue": "בעיה במערכת NMP",
    "displayPower": "בעיה במכשיר חיצוני של NMP",
    "externalPower": "בעיה במערכת MBX",
    "screen": "בעיה במכשיר חיצוני של MBX",
    "TotalRepairs": "סך כל התיקונים",
    "Repaired": "תוקן",
    "Unrepaired": "לא תוקן",
    "day": "יום",
    "Minutes": "דקות",
    "powerConsumption": "דקות",
    "Date": "תאריך",
    "kw": "KW",
    "month1": "MON",
    "month2": "TUE",
    "month3": "WED",
    "month4": "THU",
    "month5": "FRI",
    "month6": "SAT",
    "month7": "SUN",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Apr",
    "enmonth5": "May",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Aug",
    "enmonth9": "Sep",
    "enmonth10": "Oct",
    "enmonth11": "Nov",
    "enmonth12": "Dec",
    "noData": "אין נתונים"
  },
  "input": {
    "fivedigits": "נא להזין מספר שלם חי עד 5 ספרות",
    "titlUserNameField": "שם משתמש זה חייב להילקח.",
    "thisField": "שדה זה חייב להילקח.",
    "ChooseGroup": "בחר קבוצה",
    "placeholder": "בחר",
    "placeholder_type": "אנא בחר סוגי בקרת התקן",
    "titlRealNameField": "סיסמה חייבת להיות מוזנת.",
    "thisPasswordField": "סיסמה חייבת להיות מוזנת.",
    "titlPassWordNub": "פחות מ-15 תווים",
    "Post": "מספרים בלבד",
    "passwordNoChinese": "תיבת הקלט הזו אינה יכולה להכיל תווים בעברית"
  },
  "transfer": {
    "all": "הכל",
    "Choose": "בחר",
    "Selected": "נבחר",
    "Subordinate": "תת-משתמש"
  },
  "setting": {
    limitPngGif: 'נתמכים רק פורמטים PNG / GIF',
    limit3M: 'גודל התמונה לא יכול לעלות על 3MB',
    setting_door_Wallpaper_text: 'גודל תמונה מומלץ: 1280x800, בפורמט PNG או GIF',

    "reduction": "שחזור",
    "limitJpg": "תמונת הפרופיל שהועלתה יכולה להיות רק בפורמט PNG!",
    "limit2M": "גודל תמונת הפרופיל שהועלתה לא יכול לעלות על 2MB!",
    "choseFile": "בחר קובץ",
    "textOne": "1. תמונת לוגו מומלצת: גודל 117*40, בפורמט PNG",
    "textTwo": "2. לאחר סיום ההעלאה, עבור ללוח מגע וודא שהוא מחובר לאינטרנט, ואז לחץ על הלוגו המקורי כדי לרענן.",
    "customizeLogo": "הגדרת לוגו לוח מגע",
    "addSuccess": "הגדרה הצליחה!",
    "settingIp": "הגדרת כתובת IP לאחסון קבצים",
    "ServerIP": "כתובת IP של השרת:",
    "ServerPort": "פורט שרת:",
    "btnSave": "שמור",
    "TimeZoneSetting": "הגדרת אזור זמן",
    "CurrentTime": "שעה נוכחית:",
    "CurrentTimeZone": "אזור זמן נוכחי:",
    "httpsSetting": "אחסון קבצים:",
    "utcName": "שעון גריניץ' UTC/GMT",
    "utc0": "שעון גריניץ', בריטניה, ליסבון, טורשאוון, לונדון, דבלין, אדינבורו",
    "utc0_5": "",
    "utc1": "מרכז אירופה, מערב אפריקה, מערב מרכז אפריקה, גרמניה, אירלנד, צרפת, אמסטרדם, איטליה, ברלין, רומא, ספרד, פראג, בלגרד, בריסל, פריז, מדריד, תוניסיה, גבון, מרוקו",
    "utc1_5": "",
    "utc2": "מזרח אירופה, מרכז אפריקה, טורקיה, ישראל, דרום אפריקה, איסטנבול, קהיר, אתונה, דמשק",
    "utc2_5": "",
    "utc3": "מזרח אפריקה, רוסיה, בגדד, כווית, מוסקבה, סנט פטרסבורג",
    "utc3_5": "איראן",
    "utc4": "אבו דאבי, טביליסי, דובאי, מאוריציוס, פורט לואי",
    "utc4_5": "אפגניסטן",
    "utc5": "פקיסטן, טורקמניסטן, המלדיביים, אוזבקיסטן, ארמניה, טג'יקיסטאן, הודו (מומבאי, ניו דלהי, בנגלור, קולקטה)",
    "utc5_5": "הודו, סרי לנקה",
    "utc6": "נובוסיבירסק, קירגיזסטן, בנגלדש, בהוטן",
    "utc6_5": "איי קוקוס, אוסטרליה, וייטנאם",
    "utc7": "תאילנד (בנגקוק), האנה, ג'קרטה",
    "utc7_5": "",
    "utc8": "סין, מלזיה, פיליפינים, סינגפור, טאיוואן, סין (מקאו), סין (הונג קונג)",
    "utc8_5": "",
    "utc9": "יפן, דרום קוריאה, טוקיו, סיאול, סאפורו, אוסקה, מזרח טימור",
    "utc9_5": "שעת תקן מרכזית של אוסטרליה",
    "utc10": "אוסטרליה, ולדיבוסטוק, גואם, קנברה, מלבורן, סידני, פפואה ניו גיני",
    "utc10_5": "אי לורד הווא של ניו סאות' ויילס, אוסטרליה",
    "utc11": "איי שלמה, סחלין",
    "utc11_5": "אי נורפוק, אוסטרליה",
    "utc12": "ניו זילנד, אוקלנד, ולינגטון, פיג'י, ניו זילנד, נאורו",
    "utc12_5": "",
    "utc13": "קייפ ורדה, האזורות",
    "utc13_5": "",
    "utc14": "דרום ג'ורג'יה, פרננדו דה נורוניה",
    "utc14_5": "",
    "utc15": "ברזיל, סנטיאגו, אל סלוודור, ברזיליה, אורוגוואי, ארגנטינה, סורינאם",
    "utc15_5": "שעון תקן ניו-פאונדלנד",
    "utc16": "ונצואלה, בוליביה, פרגוואי, צ'ילה",
    "utc16_5": "ונצואלה",
    "utc17": "שעון מזרחי (ארה\"ב וקנדה), קולומביה, טורונטו, אקוודור, פרו, קובה, ניו יורק, המילטון, סן דייגו",
    "utc17_5": "",
    "utc18": "שעון מרכזי של ארה\"ב וקנדה, מקסיקו סיטי, מונטריי, שיקגו, יוסטון, ניו אורלינס, ממפיס",
    "utc18_5": "",
    "utc19": "שעון הרים, אריזונה, מאזאטלאן, פיניקס, סולט לייק סיטי, דנבר, אדמונטון",
    "utc19_5": "",
    "utc20": "שעון האוקיינוס השקט, לוס אנג'לס, סן פרנסיסקו, ונקובר, סיאטל, לאס וגאס",
    "utc20_5": "",
    "utc21": "אלסקה",
    "utc21_5": "פולינזיה הצרפתית, איי מרקס",
    "utc22": "הוואי",
    "utc22_5": "",
    "utc23": "סמואה, ניואי",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "שם המכשיר:",
    "Time": "זמן:",
    "startDate": "תאריך התחלה",
    "endedDate": "תאריך סיום",
    "or": "-",
    "Problem": "בעיה:",
    "btnSearch": "חיפוש",
    "tableNO": "לא",
    "tableDeviceName": "שם המכשיר",
    "tableGroup": "קבוצה",
    "tableStatus": "סטטוס",
    "tableDeliveredTime": "זמן מסירה",
    "tableSubmitter": "שולח",
    "tableUpdatingTime": "זמן עדכון",
    "tableProblem": "בעיה",
    "tableAdmin": "מנהל IT",
    "tableAdminReply": "תשובת מנהל",
    "tableAttachment": "קובץ מצורף",
    "state0": "נמסר",
    "state1": "בתהליך",
    "state2": "הושלם",
    "Problem100": "הכל",
    "Problem0": "בעיה במערכת",
    "Problem1": "בעיה במכשיר חיצוני",
    "ProblemType": "",
    "ProblemType0": "בקרת כוח",
    "ProblemType1": "מתג HDMI",
    "ProblemType2": "מיקרופון",
    "ProblemType3": "רמקול",
    "ProblemType4": "מזגן",
    "ProblemType5": "מסך מקרן",
    "ProblemType6": "מנעול חשמלי",
    "ProblemType7": "שידור A/V",
    "ProblemType8": "בקרת IR",
    "ProblemType9": "בקרת סידורי",
    "dialogDeviceName": "שם המכשיר",
    "dialogDeviceID": "מזהה מכשיר",
    "dialogGroup": "קבוצה",
    "dialogSubmitter": "שולח",
    "dialogStatus": "בחר סטטוס",
    "dialogProblem": "בעיה",
    "dialogNotes": "הערות",
    "dialogRepairation": "תיקון",
    "dialogInProcess": "בתהליך",
    "dialogCompleted": "הושלם",
    "editSuccess": "עריכה הצליחה!",
    "editError": "עריכה נכשלה!",
    "problemRequired": "אנא בחר סוג בעיה",
    "detailRequired": "אנא פרט את הבעיה",
    "statusRequired": "אנא בחר סטטוס יומן",
    "btnCancel": "ביטול",
    "DeliveredTime": "זמן מסירה",
    "UpdatingTime": "זמן עדכון",
    "ITAdmin": "מנהל IT",
    "AdminReply": "תשובת מנהל",
    "Note": "הערה",
    "Detail": "פרטים",
    "controlPanel": "לוח בקרה",
    "DeviceType": "סוג",
    "dialogDeliveredTime": "זמן מסירה",
    "Submitter": "שולח"
  },
  "remoteControl": {
    "QuickActionName": "שם",
    "DeviceType": "סוג",
    "Description": "תיאור",
    "tableDescription": "תיאור",
    "editRemoteControl": "ערוך קוד של שלט רחוק",
    "QuickActionNameInput": "שם",
    "DescriptionInput": "תיאור",
    "save": "שמור",
    "Brand": "מותג",
    "Model": "דגם",
    "EditACControlCode": "ערוך קוד של בקרת מזגן",
    "acBrand": "מותג מזגן",
    "acModel": "דגם מזגן"
  },
  "card": {
    "btnAddCard": "הוסף כרטיס",
    "btnBatchAddCard": "הוסף כרטיסים בכמות",
    "tableCard": "מספר כרטיס",
    "tableState": "סטטוס",
    "tableUser": "קשר למשתמש",
    "tableID": "שם משתמש",
    "tableType": "סוג כרטיס",
    "tableFfective": "תאריך תפוגה",
    "dialogCard": "מספר כרטיס：",
    "dialogState": "סטטוס：",
    "dialogUser": "קשר למשתמש：",
    "dialogID": "שם משתמש：",
    "dialogType": "סוג כרטיס：",
    "dialogFfective": "תאריך תפוגה：",
    "dialogRemarks": "הערות：",
    "dialogAddTitle": "הוסף כרטיס",
    "dialogEidtTitle": "ערוך כרטיס",
    "code2201": "פורמט תקופת התפוגה של הכרטיס שגוי",
    "code2202": "כרטיס זה כבר קשור",
    "code2203": "משתמש זה כבר קשור",
    "code2204": "כרטיס זה אינו קשור",
    "mastCard": "כרטיס ראשי",
    "regularCard": "כרטיס כללי",
    "permanent": "קבוע",
    "coxPermanent": "קבוע",
    "coxTime": "תקופה מסוימת",
    "tableDeviceName": "שם המכשיר",
    "tableDeviceID": "מזהה המכשיר",
    "tableOperating": "פעולה",
    "tableOperatingTime": "זמן פעולה",
    "tableCardID": "מספר כרטיס",
    "tableCardType": "סוג כרטיס",
    "tabluserName": "שם משתמש",
    "tabluserId": "מזהה משתמש",
    "unlockPanel": "שחרר פאנל",
    "unlock": "שחרר דלת",
    "conAll": "הכל",
    "btnEnable": "הפעל",
    "btnDisable": "השבת",
    "enableSuccess": "הופעל בהצלחה",
    "stopSuccess": "הושבת בהצלחה",
    "enableError": "הפעל נכשל",
    "stopError": "השבת נכשל",
    "batchCard": "מספר כרטיס בכמות：",
    "titlCardField": "מספר הכרטיס אינו יכול להיות ריק",
    "titlCardFieldFormat": "רק אותיות ומספרים",
    "dialogBachAddTitle": "הוסף כרטיסים בכמות",
    "pleaseTryAgain1": "מספר כרטיס שגוי (מס'：",
    "pleaseTryAgain2": "), נסה שוב"
  },

  "privacy": {
    "PrivacyPolicy": "Microsoft Organization Binding Privacy Agreement",
    "Byusing": "Dear User,",
    "whatinformation": "Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking \"Agree,\" you confirm that you have read and accepted all terms of this agreement.",
    "EffectiveDate": "Effective Date: August 4, 2025",
    "title1": "Required Permissions & Collected Data",
    "title1Respects1": "To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:",
    "title1Respects2": "Delegated Permissions",
    "Respects2formation": "These permissions allow Q-NEX to access your Microsoft account data after login and consent:",
    "Respects2formation2": "Calendars.ReadWrite",
    "Respects2formation3": "Permission Name: Full access to user calendars",
    "Respects2formation4": "Description: Allows the app to create, read, update, and delete events in user calendars.",
    "Respects2formation5": "Purpose: Synchronize personal calendar meetings with the Q-NEX system.",
    "Respects2formation6": "offline_access",
    "Respects2formation7": "Permission Name: Maintain access to data you've granted",
    "Respects2formation8": "Description: Allows the app to access authorized data even when you're not actively using it.",
    "Respects2formation9": "Purpose: Ensures meeting information remains synced even when users are offline.",
    "Respects2formation10": "Openid",
    "Respects2formation11": "Permission Name: Sign in as you",
    "Respects2formation12": "Description: Enables login via work/school accounts and allows the app to read basic profile details.",
    "Respects2formation13": "Purpose: Authenticates user identity for security and associates profiles with meeting data.",
    "Respects2formation14": "Place.Read.All",
    "Respects2formation15": "Permission Name: Read all company places",
    "Respects2formation16": "Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.",
    "Respects2formation17": "Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.",
    "tp1": "Application Permissions (Requires Admin Consent)",
    "tp2": "These permissions enable Q-NEX to sync data automatically without manual reauthorization:",
    "tp3": "Calendars.ReadWrite",
    "tp4": "Permission Name: Read and write calendars in all mailboxes",
    "tp5": "Description: Allows the app to create, read, update, and delete calendar events without user sign-in.",
    "tp6": "Purpose: Syncs schedules from all company meeting room resource mailboxes.",
    "tp7": "Directory.Read.All",
    "tp8": "Permission Name: Read directory data",
    "tp9": "Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.",
    "tp10": "Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.",
    "tp11": "User.Read.All",
    "tp12": "Permission Name: Read all users' full profiles",
    "tp13": "Description: Allows the app to read user profiles without user sign-in.",
    "tp14": "Purpose: Identifies meeting participants.",
    "tp15": "Place.Read.All",
    "tp16": "Permission Name: Read all company places",
    "tp17": "Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.",
    "tp18": "Purpose: Retrieves full meeting room resource lists and syncs availability statuses.",
    "title2": "Purpose of Data Usage",
    "title2Respects1": "Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.",
    "title2Respects2": "Automatically update room availability to prevent scheduling conflicts.",
    "title2Respects3": "Provide a unified meeting management experience.",
    "title3": "Data Storage & Protection",
    "title3Respects1": "All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.",
    "title3Respects2": "Q-NEX does not share calendar data with third parties unless legally required or for system security.",
    "title3Respects3": "For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.",
    "title4": "Your Rights",
    "title4Respects1": "You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.",
    "title5": "Important Notes",
    "title5Respects1": "Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.",
    "title5Respects2": "Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.",
    "contactInformation": "Contact Information",
    "contactInformationContent": "If you have any questions, please contact: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/he.js